<template>
  <div  class="content audio">
    <audio controls="controls">
       <source :src="'https://docs.google.com/uc?export=download&id='+gFile.id">
            Your browser does not support the
            <code>audio</code> element.
    </audio>
    </div>
</template>

<script>
export default {
  name: 'GFileAudio',
  props: {
    gFile: Object
  }
}
</script>
